import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "navigation-desktop__container" }
const _hoisted_2 = { class: "navigation-desktop__categories" }
const _hoisted_3 = { class: "navigation-desktop__category-image-container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "navigation-desktop__category-image-spacer" }, null, -1)
const _hoisted_5 = { class: "navigation-desktop__category-name" }
const _hoisted_6 = { class: "navigation-desktop__sub-categories" }
const _hoisted_7 = { class: "navigation-desktop__sub-category-column-container" }
const _hoisted_8 = {
  key: 0,
  class: "navigation-desktop__sub-category-image-container"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "navigation-desktop__sub-category-image-spacer" }, null, -1)
const _hoisted_10 = {
  key: 1,
  class: "navigation-desktop__sub-category-list"
}
const _hoisted_11 = { class: "navigation-desktop__usp" }

import { inject, ref, computed, watch } from 'vue';

import useContext from '@/composables/useContext';
import useScrollIntent from '@/composables/useScrollIntent';
import useDebouncer from '@/composables/useDebouncer';

import ImageWithFallback from '@/components/ImageWithFallback.vue';

import { injectionKeys as litiumInjectionKeys } from '@distancify/drapejs-litium';

import { channelKey, categoryTreeKey, isNavigationOpenKey } from '@/keys';


export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationDesktop',
  setup(__props) {

const { executeAction, terminateAction } = useDebouncer();

const isNavigationOpen = inject(isNavigationOpenKey, ref(false));

const categoryTree = inject(categoryTreeKey, ref());
const toLitiumMediaUrl = inject(
  litiumInjectionKeys.toLitiumMediaUrlKey,
  () => ''
);

const channel = inject(channelKey, ref());
const rootProductsCategory = computed(
  () => channel.value?.rootProductsCategory || {}
);
const rootCategory = computed(
  () =>
    categoryTree.value?.find((c) => c.id == rootProductsCategory?.value?.id) ||
    {}
);
const { settings } = useContext();

const scrolled = ref(false);
useScrollIntent(scrolled);

const selectedCategory = ref();

watch(isNavigationOpen, () => {
  if (!selectedCategory.value) {
    selectedCategory.value = rootCategory.value?.children?.[0];
  }
});

const selectCategory = (selectedCategoryValue) => {
  executeAction(() => {
    selectedCategory.value = selectedCategoryValue;
  }, 125);
};

const cancelPendingCategorySelection = () => {
  terminateAction();
};

const isSelectedCategory = (item: any) => {
  return selectedCategory.value?.id === item.id;
};

function getCategoryOrHighlightImages(category) {
  const maxThreeImages = [...category.categoryImages, ...category.highlights];

  return maxThreeImages.length > 0 ? maxThreeImages.slice(0, 3) : [];
}

function closeNavigation() {
  isNavigationOpen.value = false;
}

const getImageUrl = (id: string, width?: number, height?: number) => {
  if (!id) {
    return '';
  }
  const maxDimensions: any = {};

  if (width) {
    maxDimensions.maxWidth = width;
  }
  if (height) {
    maxDimensions.maxHeight = height;
  }

  return toLitiumMediaUrl(id, maxDimensions);
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(rootCategory).children)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["navigation-desktop", {
      'navigation-desktop--open': _unref(isNavigationOpen),
      'navigation-desktop--scrolled': scrolled.value,
    }])
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rootCategory).children, (item) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  key: item.name,
                  class: _normalizeClass(["navigation-desktop__category-item", {
            'navigation-desktop__category-item--selected':
              isSelectedCategory(item),
          }]),
                  onMouseenter: ($event: any) => (selectCategory(item)),
                  onMouseleave: cancelPendingCategorySelection,
                  to: item.url
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _hoisted_4,
                      _createVNode(ImageWithFallback, {
                        class: "navigation-desktop__category-image",
                        image: getImageUrl(getCategoryOrHighlightImages(item)?.[0] || '', 38)
                      }, null, 8, ["image"])
                    ]),
                    _createElementVNode("div", _hoisted_5, _toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1032, ["class", "onMouseenter", "to"]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedCategory.value?.children, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.name,
                    class: "navigation-desktop__sub-category-item"
                  }, [
                    (getCategoryOrHighlightImages(item)?.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getCategoryOrHighlightImages(item), (highlight) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: highlight,
                              class: "navigation-desktop__sub-category-image-wrapper"
                            }, [
                              _hoisted_9,
                              _createVNode(ImageWithFallback, {
                                class: "navigation-desktop__sub-category-image",
                                image: getImageUrl(highlight, 0, 48)
                              }, null, 8, ["image"])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_router_link, {
                      to: item.url,
                      class: "navigation-desktop__sub-category-name"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]),
                    (item.children?.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                            return (_openBlock(), _createBlock(_component_router_link, {
                              to: child.url,
                              class: "navigation-desktop__sub-category-list-item",
                              key: child.name
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(child.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(settings)?.usp), 1)
        ], 2))
      : _createCommentVNode("", true),
    (_unref(isNavigationOpen) && _unref(rootCategory).children)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "navigation-desktop__background",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (closeNavigation()))
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})